exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flyingBird {\n  width: -webkit-fill-available;\n}\n.flyingBird-logo {\n  padding: 0 1em;\n}\n.flyingBird-title {\n  overflow: hidden;\n  padding-left: 0;\n}\n.flyingBird-title h2 {\n  margin: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  position: relative;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n.flyingBird-description {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n", ""]);

// exports
